import { render, staticRenderFns } from "./organization-risk-view.vue?vue&type=template&id=37f13ea9&scoped=true"
import script from "./organization-risk-view.vue?vue&type=script&lang=js"
export * from "./organization-risk-view.vue?vue&type=script&lang=js"
import style0 from "./organization-risk-view.vue?vue&type=style&index=0&id=37f13ea9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f13ea9",
  null
  
)

export default component.exports